module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/466.6b9780e6.png";